import React from "react";
import Thumbnail from "@amzn/meridian/thumbnail";
import Text from "@amzn/meridian/text";
import { BADGE_PHOTO_THUMBNAIL_URL } from "src/config/external-links";
import "./customUserMessage.scss";
import { formatTime } from "src/utils/dateUtils";
import { Column, Row } from "@amzn/meridian";

interface CustomUserMessageProps {
  alias: string;
  datetime: string;
  children: React.ReactNode;
  maxWidth?: string;
  className?: string;
}

const CustomUserMessage = ({
  alias,
  datetime,
  children,
  maxWidth = "100%",
  className = "custom-user-message",
}: CustomUserMessageProps) => {
  return (
    <Column className={className} spacing="200">
      <Row alignmentHorizontal="end" spacing="200">
        <Text type="h100">{alias}</Text>
        <Text type="b100" color="secondary" tag="span">
          {formatTime(new Date(datetime))}
        </Text>
      </Row>
      <Column
        className="custom-user-message__body"
        spacing="none"
        spacingInset={"200"}
      >
        <Text type="b200">{children}</Text>
      </Column>
    </Column>
  );
};

export default CustomUserMessage;
